<div class="ui label color-indicator" [style.background]="value"></div>
<input type="text" [value]="value || ''" (focus)="open()" (change)="selectedColor($event?.target?.value)" class="color-value">
<i (click)="selectedColor()" class="remove link icon"></i>
<div [class.active]="active" class="ui form colors-popup">
  <div *ngIf="themeColors" class="field">
    <label for="">Theme colors</label>
    <div class="color-swatches">
      <div *ngFor="let color of lightThemeColors" class="color-swatch" [style.backgroundColor]="color" (click)="selectedColor(color)"></div>
    </div>
    <div class="color-swatches">
      <div *ngFor="let color of themeColors" class="color-swatch" [style.backgroundColor]="color" (click)="selectedColor(color)"></div>
    </div>
    <div class="color-swatches">
      <div *ngFor="let color of darkThemeColors" class="color-swatch" [style.backgroundColor]="color" (click)="selectedColor(color)"></div>
    </div>
  </div>
  <div class="field">
    <label for="">Greys</label>
    <div class="color-swatches">
      <div *ngFor="let color of greyScale" class="color-swatch" [style.backgroundColor]="color" (click)="selectedColor(color)"></div>
    </div>
  </div>
  <div *ngIf="settings.transparent || settings.custom" class="equal width fields">
    <div *ngIf="settings.transparent" class="field">
      <button (click)="selectedColor('transparent')" class="ui labeled icon fluid button"><i class="icon hide"></i>Transparent</button>
    </div>
    <div *ngIf="settings.custom" class="field">
      <button class="ui labeled icon fluid button"><i class="icon options"></i>Custom</button>
    </div>
  </div>
</div>
